export const PLAN_WEEKLY = 'weekly';
export const PLAN_FORTNIGHTLY = 'fortnightly';
export const PLAN_THREE_WEEKLY = 'three-weekly';
export const PLAN_MONTHLY = 'monthly';
export const PLANS_ALLOWED = [
    PLAN_WEEKLY,
    PLAN_FORTNIGHTLY,
    PLAN_MONTHLY,
];

export const GIFT_TYPE_SUBSCRIPTION = 'subscription';
export const GIFT_TYPE_ONE_OFF = 'one-off';
export const SPECIAL_DATES_GIFT_COUPON = 'single+multi';

export const SECTION_CHOOSE_A_GIFT = 'chooseAGift';
export const SECTION_CHOOSE_A_BOX_TYPE = 'chooseABoxType';
export const SECTION_NUMBER_OF_DELIVERIES = 'numberOfDeliveries';
export const SECTION_DELIVERY_ADDRESS = 'deliveryAddress';
export const SECTION_FREDDIES_ADDONS = 'freddiesAddons';
export const SECTION_FREDDIES_SHOP = 'freddiesShop';
export const SECTION_DELIVERY_DATE = 'deliveryDate';
export const SECTION_GIFT_CARD = 'giftCardCompleted';

export const PRODUCT_TYPE_SINGLE = 'oneDelivery';
export const PRODUCT_TYPE_BUMPER_SINGLE = 'bumperSingle';
export const PRODUCT_TYPE_MULTI = 'multipleDeliveries';
export const PRODUCT_TYPE_BUMPER_MULTI = 'bumperMulti';
export const PRODUCT_TYPE_POP_SINGLE = 'popSingle';
export const PRODUCT_TYPE_POP_MULTI = 'popMulti';

export const PRODUCT_FAMILY_BUMPER = 'bumper';
export const PRODUCT_FAMILY_STANDARD = 'standard';
export const PRODUCT_FAMILY_LITE = 'lite';

export const DISPLAY_NAME_BUMPER = 'Showstopper';
export const DISPLAY_NAME_STANDARD = 'Classic';
export const DISPLAY_NAME_LITE = 'Mini';

export const FREE_HURRICANE_VASE = 'NP Hurricane vase - free';
